<template>
  <div
    id="app"
    @mousemove="omMouseMove"
    @scroll="onScroll"
  >
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      active: true,
      isRouterAlive: true
    }
  },
  created() {
    // this.init();
    // this.online();
  },
  methods: {
    async init() {
      await this.ws.connect({})

      this.ws.client.subscribe(
        '/event/response',
        (response) => {
          // console.log(response);
        },
        {}
      )

      // setInterval(this.ping, 1000 * 60);

      setInterval(this.incOnlineTime, 1000 * 60)
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    ping() {
      this.ws.client.send(
        '/event/request',
        {},
        JSON.stringify({
          type: 'PING',
          data: 'ping!'
        })
      )
    },
    incOnlineTime() {
      this.ws.client.send(
        '/event/request',
        {},
        JSON.stringify({
          type: 'ONLINE_TIME',
          data: JSON.stringify({
            userId: 1,
            time: 1000 * 60
          })
        })
      )
    },

    online() {
      setInterval(this.startOnline, 5000)
    },

    omMouseMove(e) {
      // console.log(e);
      this.active = true
    },
    onScroll(e) {
      console.log(e)
    },

    async startOnline() {
      if (this.active) {
        const path = this.$route.path
        let moduleName = ''
        switch (true) {
          case /product/.test(path):
            moduleName = '商品百科'
            break
          case /ovop/.test(path):
            moduleName = '一村一品'
            break
          case /service/.test(path):
            moduleName = '商品营销'
            break
          case /my/.test(path):
            moduleName = '个人中心'
            break
          default:
            moduleName = ''
        }
        const response = await this.ajax.doPost({
          packageName: 'user',
          className: 'userOnline',
          methodName: 'create',
          params: {
            userId: this.$store.state.sys.sysUser.me.id,
            moduleName,
            moduleResourceId: this.$route.params.id,
            path,
            clientStartTime: new Date().toISOString()
          }
        })

        setTimeout(this.endOnline, 5000, response.id)
      }
    },

    async endOnline(id) {
      const response = await this.ajax.doPost({
        packageName: 'user',
        className: 'userOnline',
        methodName: 'update',
        params: {
          id,

          clientEndTime: new Date().toISOString()
        }
      })

      this.active = false
    }
  }
}
</script>

<style lang="less">
body {
  margin: 0;
  min-width: 1300px;
}
</style>
